import React, { forwardRef, useState } from "react";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";

type PasswordInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">;

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(({ className = "", ...props }, ref) => {
  const [visible, setVisible] = useState(false);
  const Toggle = visible ? EyeSlashIcon : EyeIcon;

  return (
    <div className="relative">
      <input ref={ref} type={visible ? "text" : "password"} className={`${className} pr-10`} {...props} />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-500 hover:text-brand"
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
      >
        <Toggle className="h-5 w-5" />
      </button>
    </div>
  );
});

export default PasswordInput;
